import { STATUS_WAITING_PAYMENT } from "@/constants/propertiesCollection";

export default {
  type: "properties-collections",
  name: "",
  status: STATUS_WAITING_PAYMENT,
  acquisition_number: "",
  acquisition_method: "",
  property_number: "",
  mrc_fees: null,
  origin: null,
  reference_css: null,
  approved_at: null,
  owed_taxes_school_board: null,
  owed_taxes_municipality: null,
  registration_number: null,
  excerpt: "",
  batch_numbers: [
    {
      value: null,
    },
  ],
  cancel_reason: null,
  designation_translate: null,
  property_type: "",
  country: "Canada",
  state: "Quebec",
  city: "",
  zipcode: "",
  address: "",
  infos_links: null,
  relationshipNames: ["organization", "owners", "allowedLocations", "registrationDivision"],
  organization: {
    type: "organizations",
    id: null,
  },
  registrationDivision: {
    type: "registration-divisions",
    id: null,
  },
  owners: [],
  allowedLocations: [],
};
